import { render, staticRenderFns } from "./reldemonstrativoresultados.vue?vue&type=template&id=3f2666f2&"
import script from "./reldemonstrativoresultados.vue?vue&type=script&lang=js&"
export * from "./reldemonstrativoresultados.vue?vue&type=script&lang=js&"
import style0 from "./reldemonstrativoresultados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports